import _extends from "@babel/runtime/helpers/esm/extends";

/**
 * @file
 * @author dailin01
 */
var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { useContext, useCallback } from 'react';
import classNames from 'classnames';
import Tooltip from '../tooltip';
import { isValidElement, cloneElement } from '../_util/reactNode';
import { Item } from './rc-menu';
import MenuContext from './MenuContext';
import { MenuContext as BaseMenuContext } from './rc-menu/context/MenuContext';

var MenuItem = function MenuItem(props) {
  var _a;

  var children = props.children,
      icon = props.icon,
      title = props.title,
      rest = __rest(props, ["children", "icon", "title"]);

  var contextValue = useContext(MenuContext);
  var baseMenuContextValue = useContext(BaseMenuContext);
  var inlineCollapsed = baseMenuContextValue.inlineCollapsed;
  var prefixCls = contextValue.prefixCls,
      firstLevel = contextValue.firstLevel;
  var tooltipTitle = title;

  if (typeof title === 'undefined') {
    tooltipTitle = firstLevel && inlineCollapsed ? children : '';
  }

  var tooltipProps = {
    title: tooltipTitle
  };
  var renderItemChildren = useCallback(function () {
    var wrapNode = /*#__PURE__*/React.createElement("span", {
      className: "".concat(prefixCls, "-title-content")
    }, children); // 如果是收起 + 没有ICON 显示MenuItem第一个字

    if (!icon || isValidElement(children) && children.type === 'span') {
      if (children && firstLevel && inlineCollapsed && typeof children === 'string') {
        return /*#__PURE__*/React.createElement("div", {
          className: "".concat(prefixCls, "-inline-collapsed-noicon")
        }, children.charAt(0));
      }

      return children;
    }

    return wrapNode;
  }, [children, firstLevel, icon, inlineCollapsed, prefixCls]);
  return /*#__PURE__*/React.createElement(Tooltip, _extends({}, tooltipProps, {
    placement: 'right'
  }), /*#__PURE__*/React.createElement(Item, rest, cloneElement(icon, {
    className: classNames(isValidElement(icon) ? (_a = icon.props) === null || _a === void 0 ? void 0 : _a.className : '', "".concat(prefixCls, "-item-icon"))
  }), renderItemChildren()));
};

export default MenuItem;